import React from "react";
import AppSidebar from "../layout/drawer/AppSidebar.component";
import { SidebarProvider, SidebarInset, SidebarTrigger } from "@/components/ui/sidebar";
import Notifications from "../layout/Notifications/Notifications.component";

const DashboardLayout = ({ children }) => {
  return (
    <SidebarProvider>
      <AppSidebar />

      {/* SidebarInset handles the dynamic margin offset from AppSidebar */}
      <SidebarInset className="flex flex-col h-dvh bg-background">
        
        {/* Top bar within the main content area */}
        <header 
          className="flex h-18 flex-shrink-0 items-center justify-between border-b border-border bg-card px-4 shadow-sm sticky top-0 z-30"
        >
          {/* Left side: Sidebar toggle button */}
          <div>
            <SidebarTrigger className="p-2 -ml-2 rounded-md hover:bg-muted" />
          </div>

          {/* Right side: Notifications component will render its button here if path matches */}
          <div>
            <Notifications /> 
          </div>
        </header>

        {/* Main scrollable content area */}
        {/* pt-0 because the header above now defines the top space */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          {children}
        </main>

      </SidebarInset>
    </SidebarProvider>
  );
};

export default DashboardLayout;